import { render, staticRenderFns } from "./SponsoredRecommendationSingleQTV.vue?vue&type=template&id=5fa71bd0"
import script from "./SponsoredRecommendationSingleQTV.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationSingleQTV.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports